export enum RankingErrorState {
    FetchError = 'fetchError',
    NoGameId = 'noGameId'
}
